var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHiddenEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.9993C13.6569 14.9993 15 13.6561 15 11.9993C15 10.3424 13.6569 8.99927 12 8.99927C10.3431 8.99927 9 10.3424 9 11.9993C9 13.6561 10.3431 14.9993 12 14.9993Z",
    fill: "#8993A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.12966 11.9993C5.99806 15.3785 9.03121 16.9993 12 16.9993C14.9688 16.9993 18.0019 15.3785 19.8703 11.9993C18.0019 8.62005 14.9688 6.99927 12 6.99927C9.03121 6.99927 5.99806 8.62005 4.12966 11.9993ZM12 4.99927C15.9031 4.99927 19.7362 7.23562 21.8944 11.5521C22.0352 11.8336 22.0352 12.165 21.8944 12.4465C19.7362 16.7629 15.9031 18.9993 12 18.9993C8.09687 18.9993 4.26379 16.7629 2.10557 12.4465C1.96481 12.165 1.96481 11.8336 2.10557 11.5521C4.26379 7.23562 8.09687 4.99927 12 4.99927Z",
    fill: "#8993A0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.12966 11.9993C5.99806 15.3785 9.03121 16.9993 12 16.9993C14.9688 16.9993 18.0019 15.3785 19.8703 11.9993C18.0019 8.62005 14.9688 6.99927 12 6.99927C9.03121 6.99927 5.99806 8.62005 4.12966 11.9993ZM12 4.99927C15.9031 4.99927 19.7362 7.23562 21.8944 11.5521C22.0352 11.8336 22.0352 12.165 21.8944 12.4465C19.7362 16.7629 15.9031 18.9993 12 18.9993C8.09687 18.9993 4.26379 16.7629 2.10557 12.4465C1.96481 12.165 1.96481 11.8336 2.10557 11.5521C4.26379 7.23562 8.09687 4.99927 12 4.99927Z",
    fill: "#8993A0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.36648 2.62867C4.79378 2.27877 5.42383 2.34152 5.77373 2.76882L19.7737 19.8657C20.1236 20.293 20.0609 20.9231 19.6336 21.273C19.2063 21.6229 18.5762 21.5602 18.2263 21.1329L4.22633 4.03593C3.87643 3.60862 3.93917 2.97858 4.36648 2.62867Z",
    fill: "#8993A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiddenEye);
export default __webpack_public_path__ + "static/media/hiddenEYE.300fbaf834913a3a3e74115c19fba2d3.svg";
export { ForwardRef as ReactComponent };